// extracted by mini-css-extract-plugin
module.exports = {"cards":"styles_cards__OLRu5","title":"styles_title__2tAl8"};